export default __webpack_public_path__ + "static/media/liveuser.ccd163e4.png";